import { Layout } from "../components/Layout"

export const About = () => (
  <Layout active="about" panel={undefined}>
    <section className="mx-auto flex max-w-2xl flex-col gap-4 px-6 py-24">
      <h1 className="text-3xl font-semibold">About</h1>
      <p className="text-muted-foreground">
        PDF View is built by Rotostampa on the same engine that imposes our own print jobs: files
        never leave your machine, everything runs in the browser.
      </p>
    </section>
  </Layout>
)
